import InfiniteScroll from "infinite-scroll";

class Infinite {
  constructor(infinite) {
    this.$infinite = infinite;
    this.$loadmore = document.querySelector('.js-loadmore');
    this.infScroll = null;
    if (this.$loadmore) this.setInfinite();
  }

  setInfinite() {
    this.infScroll = new InfiniteScroll(this.$infinite, {
      path: ".js-loadmore",
      append: ".item",
      button: ".js-loadmore",
      scrollThreshold: false,
    });

    this.infScroll.on("append", function (body, path, items, response) {
      let firstItem = items[0];
      firstItem.querySelector("a").focus();
    });
  }

  destroy() {
    if (this.infScroll) {
      this.infScroll.destroy();
      this.infScroll = null;
    }
  }
}

export default Infinite;
